/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/enums';
import '../resources/datatypes';
import '../../resources/error';
import './interfaces-common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "SearchCatalogObjectsRequest": {
                        "fields": {
                          "cursor": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "objectTypes": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObjectType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "includeDeletedObjects": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeRelatedObjects": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "beginTime": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "query": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogQuery",
                            "id": 6,
                            "rule": "optional"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 7,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "includeCounts": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 10,
                            "rule": "optional"
                          },
                          "includeNestedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.InlineTypes",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": "INLINE_ALL"
                            }
                          },
                          "includeCategoryPathToRoot": {
                            "type": "bool",
                            "id": 12,
                            "rule": "optional"
                          },
                          "queryMatchAny": {
                            "type": "bool",
                            "id": 13,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeCategoryEnablementsForCombos": {
                            "type": "bool",
                            "id": 14,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "followNestedCategories": {
                            "type": "bool",
                            "id": 15,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeInventory": {
                            "type": "bool",
                            "id": 16,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "includeOptions": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.IncludeOptions",
                            "id": 17,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "relatedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "latestTime": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "categoryEnablementsForCombos": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CategoryEnablementForCombos",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "includedResources": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.IncludedResources",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/search-catalog-obj.proto at 20:1
 */
export const SearchCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogObjectsRequest');
fixType(SearchCatalogObjectsRequest);
Builder.createAndAttachToType(SearchCatalogObjectsRequest);
/**
 * SOURCE SearchCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/search-catalog-obj.proto at 175:1
 */
export const SearchCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogObjectsResponse');
fixType(SearchCatalogObjectsResponse);
Builder.createAndAttachToType(SearchCatalogObjectsResponse);